/**
 * List of apache directives to access web services
 */
export const ILH_WS = {
  ilh: "ussiiws"
};

/**
 * Individual Life and Health web services
 */
export const ILH_URL = {
  COMPANY_LIST: ILH_WS.ilh + "/wii101aa.pgm",

  NOTES_TYPE_LIST: ILH_WS.ilh + "/wii101f.pgm",
  NOTES_TYPE_MAINTENANCE: ILH_WS.ilh + "/wii101g.pgm",
  NOTES_TYPE_DELETE: ILH_WS.ilh + "/wii101h.pgm",
  NOTES_TEMPLATE_LIST: ILH_WS.ilh + "/wii101i.pgm",
  NOTES_TEMPLATE_MAINTENANCE: ILH_WS.ilh + "/wii101j.pgm",
  NOTES_TEMPLATE_DELETE: ILH_WS.ilh + "/wii101k.pgm",

  CLIENT_LIST: ILH_WS.ilh + "/wii102aa.pgm",
  CLIENT_DETAILS: ILH_WS.ilh + "/wii102ab.pgm",
  CLIENT_RELATIONSHIP_LIST: ILH_WS.ilh + "/wii102ac.pgm", // Entire list of relationships. Currently not used.
  CLIENT_RELATIONSHIP_SUMMARY_LIST: ILH_WS.ilh + "/wii102ad.pgm",
  CLIENT_RELATIONSHIP_DETAIL_LIST: ILH_WS.ilh + "/wii102ae.pgm",
  POLICY_LIST: ILH_WS.ilh + "/wii103aa.pgm",
  POLICY_DETAILS: ILH_WS.ilh + "/wii103ab.pgm",
  POLICY_HOUSEHOLD: ILH_WS.ilh + "/wii103ac.pgm",
  POLICY_DIVIDENDS: ILH_WS.ilh + "/wii103ad.pgm",
  POLICY_CASH_VALUES: ILH_WS.ilh + "/wii103ae.pgm",
  POLICY_PREMIUM_HISTORY: ILH_WS.ilh + "/wii103af.pgm",
  POLICY_PREMIUM_HISTORY_FILE: ILH_WS.ilh + "/wii103ag.pgm",
  POLICY_BENEFITS: ILH_WS.ilh + "/wii103ah.pgm",
  POLICY_BENEFITS_DETAILS: ILH_WS.ilh + "/wii103ai.pgm",
  POLICY_COVERAGES: ILH_WS.ilh + "/wii103aj.pgm",
  POLICY_COMMISSION_INFO: ILH_WS.ilh + "/wii103ak.pgm",
  POLICY_TEMP: ILH_WS.ilh + "/wii103al.pgm", // TODO: Rename and update when WS complete
  POLICY_POLICY_MESSAGES: ILH_WS.ilh + "/wii103am.pgm",
  POLICY_RELATIONSHIP_SUMMARY_LIST: ILH_WS.ilh + "/wii103an.pgm",
  POLICY_RELATIONSHIP_DETAIL_LIST: ILH_WS.ilh + "/wii103ao.pgm",
  CLAIMS_CLAIM_INFO: ILH_WS.ilh + "/wii103ap.pgm",
  POLICY_RELATIONSHIP_LIST: ILH_WS.ilh + "/wii103aq.pgm", // Entire list of relationships. Currently not used.
  POLICY_ADDRESS_LIST: ILH_WS.ilh + "/wii103ar.pgm",

  NOTES_LIST: ILH_WS.ilh + "/wii104aa.pgm",
  NOTES_MAINTENANCE: ILH_WS.ilh + "/wii104ab.pgm",
  NOTES_DELETE: ILH_WS.ilh + "/wii104ac.pgm",

  STATE_LIST: ILH_WS.ilh + "/wii105aa.pgm",

  // TODO
  NOTES_USER_SETTINGS: ILH_WS.ilh + "/wii101aa.pgm",
  NOTES_USER_SETTINGS_MAINTENANCE: ILH_WS.ilh + "/wii102ba.pgm"
};
